var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c("div", { staticClass: "md:pl-10 w-full md:pr-20" }, [
      _c("form", { attrs: { method: "POST" } }, [
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { ref: "title", attrs: { for: "title" } }, [
            _vm._v("\n                    Resource Title "),
            _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            _vm._v(" "),
            _c("div", { staticClass: "text-sm font-sans-book" }, [
              _vm._v("50 character maximum (including spaces)."),
            ]),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:50",
                expression: "'required|max:50'",
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.title,
                expression: "form.title",
              },
            ],
            attrs: { id: "title", type: "text", name: "title" },
            domProps: { value: _vm.form.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "title", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
            [_vm._v("Character count: " + _vm._s(_vm.characterCount))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("title"),
                  expression: "errors.has('title')",
                },
              ],
              staticClass: "error text-error-red text-lg",
            },
            [_vm._v(_vm._s(_vm.errors.first("title")))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { ref: "types", attrs: { for: "title" } }, [
            _vm._v("\n                    What type of resource is this? "),
            _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            _vm._v(" "),
            _c("div", { staticClass: "text-sm font-sans-book" }, [
              _vm._v(
                'Make up to three choices. Select "Article" when creating a new written resource directly through this site.'
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "group__checkbox" }, [
            _c(
              "div",
              { staticClass: "select-box flex flex-wrap" },
              _vm._l(_vm.types, function (type) {
                return _c(
                  "label",
                  {
                    key: type.id,
                    staticClass:
                      "text-base font-normal w-full md:w-1/2 md:pr-3",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.types,
                          expression: "form.types",
                        },
                      ],
                      attrs: {
                        name: "types",
                        type: "checkbox",
                        disabled:
                          _vm.maxMet && _vm.form.types.indexOf(type.id) == -1,
                      },
                      domProps: {
                        value: type.id,
                        checked: Array.isArray(_vm.form.types)
                          ? _vm._i(_vm.form.types, type.id) > -1
                          : _vm.form.types,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.types,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = type.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.form, "types", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "types",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "types", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "check inline-block mr-2" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "flex-1" }, [
                      _vm._v(_vm._s(type.title)),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("types"),
                    expression: "errors.has('types')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("types")))]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { ref: "price", attrs: { for: "title" } }, [
            _vm._v("\n                    Is this a paid or free resource? "),
            _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "group__radio" }, [
            _c(
              "div",
              { staticClass: "select-box flex flex-wrap" },
              _vm._l(_vm.prices, function (price) {
                return _c(
                  "label",
                  {
                    key: price.id,
                    staticClass:
                      "text-base font-normal w-full md:w-1/2 md:pr-3",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.price,
                          expression: "form.price",
                        },
                      ],
                      attrs: { name: "price", type: "radio" },
                      domProps: {
                        value: price.id,
                        checked: _vm._q(_vm.form.price, price.id),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.form, "price", price.id)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "radio inline-block mr-2" }),
                    _vm._v(
                      " " + _vm._s(price.price) + "\n                        "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("price"),
                    expression: "errors.has('price')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("price")))]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { ref: "locations", attrs: { for: "title" } }, [
            _vm._v(
              "\n                    Is this resource only available in a specific location? If so, where?\n                    "
            ),
            _c("div", { staticClass: "text-sm font-sans-book mb-2" }, [
              _vm._v(
                "If the resource is available everywhere or is not limited by location, please leave all boxes unchecked."
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "group__radio" }, [
            _c(
              "div",
              { staticClass: "select-box flex flex-wrap" },
              _vm._l(_vm.locations, function (location) {
                return _c(
                  "label",
                  {
                    key: location.id,
                    staticClass:
                      "text-base font-normal w-full md:w-1/2 md:pr-3",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.locations,
                          expression: "form.locations",
                        },
                      ],
                      attrs: { name: "locations", type: "checkbox" },
                      domProps: {
                        value: location.id,
                        checked: Array.isArray(_vm.form.locations)
                          ? _vm._i(_vm.form.locations, location.id) > -1
                          : _vm.form.locations,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.locations,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = location.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "locations",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "locations",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "locations", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "check inline-block mr-2" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "flex-1" }, [
                      _vm._v(_vm._s(location.title)),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("locations"),
                    expression: "errors.has('locations')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("locations")))]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { attrs: { for: "title" } }, [
            _vm._v(
              "\n                    If other please share the location so it can be included in future updates.\n                "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.otherLocation,
                expression: "form.otherLocation",
              },
            ],
            attrs: { id: "otherLocation", type: "text", name: "otherLocation" },
            domProps: { value: _vm.form.otherLocation },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "otherLocation", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-12" },
          [
            _c("label", { attrs: { for: "url" } }, [
              _vm._v(
                "\n                    If there is one, share a specific website where people can learn more about this resource.\n                "
              ),
            ]),
            _vm._v(" "),
            _c("url-input", {
              model: {
                value: _vm.form.url,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "url", $$v)
                },
                expression: "form.url",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-6 border-top flex flex-wrap" }, [
          _c(
            "button",
            {
              staticClass: "button",
              class: { "opacity-50 cursor-not-allowed": _vm.saving },
              attrs: { disabled: _vm.saving },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "mr-0 md:mr-4 mb-4 md:mb-4 w-full md:w-auto",
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              class: { "opacity-50 cursor-not-allowed": _vm.saving },
              attrs: { disabled: _vm.saving },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.saveNext.apply(null, arguments)
                },
              },
            },
            [_vm._v("Save & Next")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }